import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const InventoryPages = {
  list: 'ListInventory',
  add: 'AddInventory',
  edit: 'EditInventory',
}

const { t } = i18n.global

const title = t('pages.listInventory')
const path = '/inventories'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: InventoryPages.add,
  component: () => import('@/pages/mainPageWithRoute/inventory/AddInventoryPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: InventoryPages.edit,
  component: () => import('@/pages/mainPageWithRoute/inventory/EditInventoryPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: InventoryPages.list,
  component: () => import('@/pages/mainPageWithRoute/inventory/ListInventoryPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Inventories: RouteRecordRaw = {
  path,
  name: 'Inventories',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
